/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Stat } from './Stat';

class CertExamPayStat extends Stat {
    constructor() {
        super();
        this.baseUrl += '/certExamPayStat';
    }

    findCertExamPayStatList({
        certCatId,
        certExamType,
        orgId,
        statTime,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let statTimeBegin = null;
        let statTimeEnd = null;
        if (statTime != null && statTime.length === 2) {
            [statTimeBegin, statTimeEnd] = statTime;
        }
        return super.get('/findCertExamPayStatList', {
            certCatId,
            certExamType,
            orgId,
            statTimeBegin,
            statTimeEnd,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }
}

export default new CertExamPayStat();
export { CertExamPayStat };
